import { buildMaybePartnerRoute } from '../../helpers/builders.js';
import { ChartingFlowRouteName } from './model.js';

const chartingFlowPrintRequisitionFormsRoute = (orderID, locationData) => buildMaybePartnerRoute({
    ...locationData,
    name: ChartingFlowRouteName.PRINT_REQUISITION_FORMS,
    path: `/print-requisition-forms/${orderID}`,
    params: {
        orderID,
        ...locationData === null || locationData === void 0 ? void 0 : locationData.params,
    },
});
const chartingFlowSpecimenBagsRoute = (orderID, isDraft, locationData) => buildMaybePartnerRoute({
    ...locationData,
    name: ChartingFlowRouteName.SPECIMEN_BAGS,
    path: `/specimen-bags/${orderID}`,
    params: {
        orderID,
        isDraft: isDraft ? 'true' : 'false',
    },
});

export { chartingFlowPrintRequisitionFormsRoute, chartingFlowSpecimenBagsRoute };
